export class Specialist {
  constructor(
    public id: string = null,
    public username: string = null,
    public firstName: string = null,
    public lastName: string = null,
    public isAdmin = false,
    public isEnrolledInDocuSign = false,
    public docusignUserId: string = null,
    public isSkillsInitialized = false,
  ) {}

  public get fullName(): string {
    return `${this.firstName} ${this.lastName}`;
  }
}
